import React, { ReactNode } from "react";
import { ThemeProvider, Toolbar, createTheme } from "@mui/material";
import { classNames } from "../../models/models";

type TableToolbarProps = {
  className?: string;
  children?: ReactNode
};

const TableToolbar = ({ className, children }: TableToolbarProps) => {
  const theme = createTheme({
    components: {
      MuiToolbar: {
        styleOverrides: {
          root: {
            backgroundColor: "#22242D",
            borderRadius: 4,
            color: "#C7C9CD"
          }
        }
      }
    }
  });

  return (
    <ThemeProvider theme={theme}>
      <Toolbar className={classNames(className)}>
        {children}
      </Toolbar>
    </ThemeProvider>
  );
};

export default TableToolbar;